export const WORK_DAY_TIME_CHANGED = "WORK_DAY_TIME_CHANGED";
